const addKeydownEvent = (callback, timeout = 200, useCapture = false) => {
  let isPressed = false;
  const toReturn = (e) => {
    if (isPressed) return;
    isPressed = true;
    setTimeout(() => {
      isPressed = false;
    }, timeout)
    if (callback)
      callback(e);
  }
  document.addEventListener('keydown', toReturn, useCapture);
  return toReturn;
}

const removeKeydownEvent = (callback) => {
  document.removeEventListener('keydown', callback);
}

export { addKeydownEvent, removeKeydownEvent }